export default "__VITE_ASSET__C7DIatU9__"